import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutionsSection } from './components/FailedSolutionsSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { SocialProofSection } from './components/SocialProofSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { LegalSection } from './components/LegalSection';
export function App() {
  return <div className="font-body text-warmBrown bg-cream min-h-screen w-full overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedSolutionsSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <SocialProofSection data-id="element-6" />
      <ClosingSection data-id="element-7" />
      <Footer data-id="element-8" />
      <LegalSection data-id="element-9" />
    </div>;
}